import React from 'react'
import { SvgIcon } from 'src/components/icons/svg-icon'
import { CLASS_PREFIX } from 'src/constants/'
import { textResources } from 'src/lang/de'
import { AUTH_CLS } from '../../auth/constants'
import './public_profile_info.scss'

const cls = `${CLASS_PREFIX}public-profile-info`

type IProps = {
  onSelectLogin: () => void
  onSelectRegister: () => void
  onBack: () => void
  closeModal: () => void
}

export const PublicProfileInfo: React.FC<IProps> = ({ onSelectLogin, onSelectRegister, onBack, closeModal }) => {
  return (
    <div className={cls}>
      <div className={`${cls}__header`}>
        <button onClick={onBack}>
          <SvgIcon name="Arrows/chevron-left" /> {textResources.shared.back}
        </button>
      </div>
      <div className={`${cls}__content`}>
        <div>
          <div className={`${AUTH_CLS}__header`}>{textResources.authentication.publicProfileRequiresPrivateTitle}</div>
          <div className={`${AUTH_CLS}__subheader`}>
            {textResources.authentication.publicProfileRequiresPrivateSubtitle}
          </div>
        </div>
        <div className={`${cls}__tiles`}>
          <div className={`${cls}__tile`} onClick={onSelectLogin}>
            <div className={`${cls}__tile_description`}>
              <div>{textResources.authentication.alreadyHavePrivateProfile}</div>
              <div className={`${cls}__tile_description_title`}>{textResources.authentication.loginToYourAccount}</div>
            </div>
          </div>
          <div className={`${cls}__tile`} onClick={onSelectRegister}>
            <div className={`${cls}__tile_description`}>
              <div>{textResources.authentication.newHereGetStarted}</div>
              <div className={`${cls}__tile_description_title`}>{textResources.authentication.createPrivateProfile}</div>
            </div>
          </div>
        </div>
        <button className={`${cls}__close`} onClick={closeModal}>{textResources.shared.close}</button>
      </div>
    </div>
  )
}
